// extracted by mini-css-extract-plugin
module.exports = {"avatar":"ChatBox_avatar__YPMqd","avatarAppear":"ChatBox_avatarAppear__U5q4o","text":"ChatBox_text__JpLxL","textAppear":"ChatBox_textAppear__MjMKJ"};